import api from "./axios";

class ServicePrescriptionPreset {
  async findAll(q = "", page = 1, limit = 10) {
    const { data } = await api.get("/prescription-presets", {
      params: { q, page, limit },
    });
    return data;
  }

  async findById(id) {
    const { data } = await api.get(`/prescription-presets/${id}`);
    return data;
  }

  async save(preset) {
    const { data } = await api.post("/prescription-presets", preset);
    return data;
  }

  async update(id, preset) {
    const { data } = await api.put(`/prescription-presets/${id}`, preset);
    return data;
  }

  async delete(id) {
    await api.delete(`/prescription-presets/${id}`);
  }
}

export default new ServicePrescriptionPreset();
